export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function relativeTime(dateStr: string): string {
  const now = new Date('2026-04-28T12:00:00');
  const past = new Date(dateStr);
  const diffMs = now.getTime() - past.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH}h ago`;
  const diffD = Math.floor(diffH / 24);
  return `${diffD}d ago`;
}

export function getLast15Days(): string[] {
  const result: string[] = [];
  for (let i = 14; i >= 0; i--) {
    const d = new Date('2026-04-27');
    d.setDate(d.getDate() - i);
    result.push(
      d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })
    );
  }
  return result;
}
